import { ValidationStatus } from '@feature/validation';

/**
 * Entity types the backend can export. New types are added server side without any frontend
 * contract change, so this list is only used to label the pickers.
 */
export type ExportEntityType = 'patents' | 'books' | 'chapters' | 'awards';

export const exportEntityTypes: ExportEntityType[] = ['patents', 'books', 'chapters', 'awards'];

export type ExportLang = 'ro' | 'en';

export const exportLangs: ExportLang[] = ['ro', 'en'];

export const DEFAULT_EXPORT_LANG: ExportLang = 'ro';

export interface ExportParams {
  /** headers, sheet name, filter banner and filename language; defaults to ro server side */
  lang?: ExportLang | null;
  /** omit for all statuses */
  validationStatus?: ValidationStatus | null;
  /** omit for all years */
  year?: number | null;
}

export interface ExportedFile {
  blob: Blob;
  filename: string;
}

export type { ValidationStatus };
